module.exports = __webpack_public_path__ + "img/1596856307489005388.f2470cc2.png";